import { CheckCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { TrustScorePill } from "src/components/Common/TrustScore";
import { getOverallVerdict } from "../oprations";

const VerdictPill = ({ status }) => (
  <TrustScorePill
    icon={status === "PASS"
      ? <CheckCircleFilled style={{ color: "#2C6740", fontSize: 18 }} />
      : status === "FAIL"
        ? <CloseCircleFilled style={{ color: "#ff5267", fontSize: 18 }} />
        : null
    }
    text={status}
    bg={"transparent"}
    color={status === "PASS" ? "#2C6740" : status === "PENDING" || status === "N/A" ? "#888888" : "#ff5267"}
    tooltipText={""}
    className={`height-30 width-80 ${status === "PENDING" ? "pl-16" : status === "N/A" ? "justify-center" : ""}`}
  />
);

const getProctoringVerdict = (reportData, positionConfig) => {
  if (reportData?.disqualified) return "FAIL";
  // Decide only once positionConfig has loaded, so the column doesn't flash PASS before N/A.
  if (!positionConfig) return null;
  return positionConfig.aiProctoring ? "PASS" : "N/A";
};

const OverallSummary = ({ reportData, positionConfig }) => {
  const cutoffVerdict = reportData?.cutOffCleared === true ? "PASS" : "FAIL";
  const proctoringVerdict = getProctoringVerdict(reportData, positionConfig);
  const finalVerdict = getOverallVerdict(reportData, positionConfig);

  return (
    <div className="overall-verdict-container">
      <h4 className="overall-verdict-title">OVERALL SUMMARY</h4>
      <div className="overall-verdict-col">
        <p className="overall-verdict-label">Cutoff</p>
        <VerdictPill status={cutoffVerdict} />
      </div>
      <div className="overall-verdict-col">
        <p className="overall-verdict-label">Proctoring</p>
        {proctoringVerdict && <VerdictPill status={proctoringVerdict} />}
      </div>
      <div className="overall-verdict-col">
        <p className="overall-verdict-label">Final Result</p>
        <VerdictPill status={finalVerdict} />
      </div>
    </div>
  );
};

export default OverallSummary;
